import CaseStudySixContainer from "./containers/CaseStudySixContainer";
export default CaseStudySixContainer;
